export const getAppName = () => {
  // console.log(process.env.REACT_APP_BUILD_TARGET);
  return (
  // process.env.REACT_APP_BUILD_TARGET === 'matmissionen' ? 'Matmissionen'
  //   : process.env.REACT_APP_BUILD_TARGET === 'matratt' ? 'Maträtt'
  //   : 'App Name'
  // );
    process.env.REACT_APP_BUILD_TARGET ? process.env.REACT_APP_BUILD_TARGET : 'App Name'
  );
};